import { Drawer, Flex, Text } from '@/components';
import type { BulkCopyFormSchema } from '@/features/project/_models/group';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { BulkCopyForm } from './BulkCopyForm';

type FormValues = z.infer<typeof BulkCopyFormSchema>;

type Props = {
  open: boolean;
  fiscalYear: number | undefined;
  onSubmit: (values: FormValues) => void;
  onClose: () => void;
  isLoading: boolean;
};

export const BulkCopyFormDrawer: FC<Props> = ({
  open,
  fiscalYear,
  onSubmit,
  onClose,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer open={open} onClose={onClose} destroyOnClose>
      <Flex vertical gap="middle">
        <Text text={t('bulk-copy-confirm-message')} />
        <BulkCopyForm
          fiscalYear={fiscalYear}
          onSubmit={onSubmit}
          isLoading={isLoading}
        />
      </Flex>
    </Drawer>
  );
};
